import React from "react";
import { Trash2 } from "lucide-react";

export default function LocationsTable({ items, onDelete }) {
  if (!items.length) return <div className="bg-white border border-zinc-200 rounded-sm p-8 text-center text-zinc-400">Nessuna posizione definita</div>;
  return (
    <div className="bg-white border border-zinc-200 rounded-sm overflow-x-auto">
      <table className="w-full text-sm" data-testid="locations-table">
        <thead><tr className="bg-[#09090B] text-white text-xs uppercase tracking-wider">
          <th className="px-4 py-3 text-left">Codice</th>
          <th className="px-4 py-3 text-left">Nome</th>
          <th className="px-4 py-3 text-left">Zona</th>
          <th className="px-4 py-3 text-left">Corsia</th>
          <th className="px-4 py-3 text-left">Scaffale</th>
          <th className="px-4 py-3 text-left">Piano</th>
          <th className="px-4 py-3"></th>
        </tr></thead>
        <tbody>
          {items.map((loc, i) => (
            <tr key={loc.id || i} className="border-b border-zinc-100 hover:bg-zinc-50">
              <td className="px-4 py-3 font-mono font-bold">{loc.code}</td>
              <td className="px-4 py-3">{loc.name || "-"}</td>
              <td className="px-4 py-3">{loc.zone || "-"}</td>
              <td className="px-4 py-3">{loc.aisle || "-"}</td>
              <td className="px-4 py-3">{loc.shelf || "-"}</td>
              <td className="px-4 py-3">{loc.level || "-"}</td>
              <td className="px-4 py-3"><button onClick={() => onDelete(loc.id)} className="p-1 text-zinc-300 hover:text-red-500"><Trash2 size={16} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
